// extracted by mini-css-extract-plugin
export var removeBottomMarginCSS = "figure-module--removeBottomMarginCSS--vIub3";
export var removeFullWidthOnMobileCSS = "figure-module--removeFullWidthOnMobileCSS--uzjmd";
export var root = "figure-module--root--92gvy";